import React from 'react';
import Button from '@mui/material/Button';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@mui/styles';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useTranslate, useDataProvider } from 'react-admin';
import GetDeviceButton from './GetDevice';
import { GET_MANY } from 'ra-core';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    button: {
        display: 'flex',
        alignItems: 'center',
    },
    close: {
        padding: theme.spacing(0.5),
    },
    iconSmall: {
        fontSize: 24,
    },
}));

const BarcodeScanner = () => {
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();

    function handleClick() {
        window.cordova.plugins.barcodeScanner.scan(
            function (result) {
                if (!result.cancelled) {
                    enqueueSnackbar(translate('tim.barcodescanner.success', { r: result.text }), {
                        variant: 'info',
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000,
                    });
                    if(result.text && result.text.charAt(0) !== '%'){
                        result.text = '%'+result.text;
                    }
                    setInputValue(document.getElementById('serial_number_tim'), result.text);
                    document.getElementById('serial_number_tim').dispatchEvent(new Event('input', { bubbles: true }));

                    const serialnumber = result.text;
                    enqueueSnackbar(translate('tim.getdevice.getting_info'), {
                        variant: 'info',
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000,
                    });

                    dataProvider(GET_MANY, 'devices', { "filter": { serial_number_tim: serialnumber } })
                        .then(
                            response => {
                                if (response.total > 0) {
                                    enqueueSnackbar(translate('tim.getdevice.success', { id: response.data[0].serial_number_tim }), {
                                        variant: 'success',
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        },
                                        autoHideDuration: 3000,
                                    });

                                    window.location.replace(window.location.origin + '/#/devices/' + response.data[0].id);
                                }
                                else {
                                    enqueueSnackbar('tim.getdevice.not_found', {
                                        variant: 'warning',
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        },
                                        autoHideDuration: 3000,
                                    });
                                }
                            })
                        .catch(error => {
                            enqueueSnackbar(error.message, {
                                variant: 'error',
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                },
                                autoHideDuration: 3000,
                            });
                        });
                }
                else {
                    enqueueSnackbar(translate('tim.barcodescanner.cancelled'), {
                        variant: 'warning',
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000,
                    });
                }
            },
            function (error) {
                enqueueSnackbar(translate('tim.barcodescanner.error', { e: error }), {
                    variant: 'warning',
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    autoHideDuration: 3000,
                });
            },
            {
                preferFrontCamera: false, // iOS and Android
                showFlipCameraButton: true, // iOS and Android
                showTorchButton: true, // iOS and Android
                torchOn: false, // Android, launch with the torch switched on (if available)
                saveHistory: true, // Android, save scan history (default false)
                prompt: "Place a barcode inside the scan area", // Android
                resultDisplayDuration: 2500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                //formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                orientation: "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
                disableAnimations: true, // iOS
                disableSuccessBeep: false, // iOS and Android
                height: 200,
                width: 1000,
                showEnableScanButton: true
            }
        );
    }

    if (window.usingCordova) {
        return (
            <div className={classes.root}>
                <div className={classes.wrapper}>
                    <Button variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={handleClick}
                    >
                        <CameraAltIcon className={clsx(classes.iconSmall)} />
                    </Button>
                    <GetDeviceButton />
                </div>
            </div>);
    }
    else {
        return <GetDeviceButton />;
    }
}

function setInputValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else {
        valueSetter.call(element, value);
    }
}

export default BarcodeScanner;